import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import fi from "./fi.json";

export const LANGUAGES = ["en", "fi"] as const;
export type Language = (typeof LANGUAGES)[number];

const STORAGE_KEY = "upcloud-costs.language";

function initialLanguage(): Language {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "fi") {
        return stored;
    }
    return navigator.language.toLowerCase().startsWith("fi") ? "fi" : "en";
}

void i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, fi: { translation: fi } },
    lng: initialLanguage(),
    fallbackLng: "en",
    interpolation: { escapeValue: false },
});

/** Switches the UI language and remembers the choice. */
export function changeLanguage(language: Language): void {
    localStorage.setItem(STORAGE_KEY, language);
    void i18n.changeLanguage(language);
    document.documentElement.lang = language;
}

export default i18n;
